var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center justify-center flex-1 content-stretch "},[_c('div',{staticClass:"flex-1"},[_vm._v(" ")]),_vm._t("default"),_c('div',{staticClass:"flex-2"},[_vm._v(" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }